import Skeleton from "@mui/material/Skeleton";
import { Box, DataGrid, DataGridCardProps, GalleryPlaceholder, Text } from "designSystem/index";
import { STANDARD_BORDER_STYLE } from "designSystem/styles/style-functions";
import WorkingCache from "csi/state/WorkingCache";
import { C8Node, cnl, IDataStore } from "csi/typings";
import React from "react";

const Card = (props: DataGridCardProps<C8Node>) => {
	const { item } = props;

	return (
		<Box
			bgcolor="background.paper"
			border={STANDARD_BORDER_STYLE}
			height={1}
			p={2}
		>
			<Box height={100}>
				<Text text={item.$Name} variant="subtitle1" />
			</Box>
		</Box>
	);
};

const SkeletonCard = () => {
	return (
		<Box
			bgcolor="background.paper"
			border={STANDARD_BORDER_STYLE}
			height={1}
			p={2}
		>
			<Skeleton height={100} variant="rectangular" />
		</Box>
	);
};

const PlaceholderComponent = () => {
	return (
		<GalleryPlaceholder titleProps={{ text: "No Data" }} />
	);
};

class MockNodeDataStore implements IDataStore<C8Node> {
	private readonly cache: WorkingCache;
	private readonly urls: cnl[];
	readonly total: number;

	getIdentity = (item: C8Node) => item.$URL;
	getIdentityIndex = (id: string): number | undefined => 0;
	getNextIdentity = (id: string, previous?: boolean, defaultToFirst?: boolean): string | undefined => id;
	get = (index: number): C8Node => this.cache.get(this.urls[index]);
	load = (start: number, end: number): Promise<number> => {
		return new Promise((resolve, reject) => {
			setTimeout(() => {
				reject(new Error("There is a problem!"));
			}, 2000);
		});
	};
	move = (from: number, to: number) => { };
	remove = (id: string) => { };

	constructor(urls: cnl[], cache: WorkingCache) {
		this.urls = urls;
		this.cache = cache;
		this.total = urls.length;
	}
}

const cache = new WorkingCache();
const urls: cnl[] = [];
const store = new MockNodeDataStore(urls, cache);

export default () => {
	return (
		<DataGrid
			CardComponent={Card}
			PlaceholderComponent={PlaceholderComponent}
			SkeletonComponent={SkeletonCard}
			columns={3}
			store={store}
		/>
	);
};